<template>
    <Structure_Header_Col2 :icon="story.getIconObject()">
        <template v-slot:col-1>
            <Header_Name
                :name="story.name"
                type="Story"
                @save="saveName"
            />
        </template>
        <template v-slot:col-2>
            <Header_Tools
                :undoRedo="false"
            >
                <btn icon>
                    <i class="fal fa-cog"></i>
                    {{$t('Settings')}}
                </btn>
            </Header_Tools>
        </template>
    </Structure_Header_Col2>
</template>

<script>
import Btn from "@/modules/buttons/btn";
import {story} from "@/class/story";
import Structure_Header_Col2 from "@/views/structures/Structure_Header_Col2";
import Template from "@/layouts/Template";
import Header_Name from "@/views/header/Header_Name";
import Header_Tools from "@/views/header/Header_Tools";
import {onglets} from "@/class/onglets/onglets";

export default {
    name: "Story_Header",
    components: {Header_Tools, Header_Name, Template, Structure_Header_Col2, Btn},
    props: {
        story: {type: Object, default: () => new story()},
    },
    methods: {
        async saveName(newName){
            this.story.name = newName;
            await this.story.patch('name')
            
            this.story.onglet.title = this.story.name
            onglets.update(this.story.onglet)
        }
    },
}
</script>